function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "WalletHub_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 256",
  fill: "none",
  d: "M0 0h300.511v70.779H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 342",
  clipPath: "url(#WalletHub_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 191",
  d: "M299.838 19.962a2.025 2.025 0 11-2.027-2.025 2.018 2.018 0 012.027 2.025m-3.6 0a1.574 1.574 0 101.572-1.575 1.537 1.537 0 00-1.571 1.575m1.35 1.125h-.452v-2.025h1.352v.675a.486.486 0 01-.45.45.486.486 0 01.45.45c0 .225 0 .45.225.45h-.225v-.45h-.9z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 192",
  d: "M116.27 16.359l-3.824 22.721-4.049-22.721h-8.549L96.474 39.08l-3.6-22.721h-9.447l8.323 37.343h8.1l4.274-24.3 4.5 24.3h7.417l9-37.343z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 193",
  d: "M135.394 25.583a36.22 36.22 0 00-10.8 1.8l1.124 6.528a45.543 45.543 0 017.649-1.35 2.127 2.127 0 012.475 1.35v2.25l-3.6.45c-6.971.9-9.9 3.6-9.9 9.448s3.6 8.1 7.649 8.1a11.467 11.467 0 006.974-2.475l.677 2.025h6.522V34.356c0-6.749-2.924-8.773-8.771-8.773m-4.5 19.8a3.935 3.935 0 013.147-4.274h1.8v6.3a3.38 3.38 0 01-2.475.9 2.106 2.106 0 01-2.472-1.8c-.227-.45 0-.9 0-1.125"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 253",
  d: "M148.439 16.359h8.323v37.343h-8.323z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 254",
  d: "M161.036 16.359h8.323v37.343h-8.323z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 194",
  d: "M187.356 47.629c-3.824 0-5.4-1.35-5.849-4.949h13.273v-2.7c0-10.123-3.149-14.4-10.348-14.4s-11.7 4.724-11.7 14.847 4.274 13.947 12.6 13.947a23.843 23.843 0 009.673-1.8L193.43 46.5a19.287 19.287 0 01-6.074 1.125m-2.924-15.514c2.25 0 2.475 2.025 2.7 6.3h-5.4c-.225-4.5.45-6.3 2.7-6.3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 195",
  d: "M208.505 47.404c-.9.225-1.8 0-2.027-.9a1.03 1.03 0 010-1.125V33.456h5.624v-7.2h-5.624v-7.872l-8.323 3.149v25.2c0 5.624 1.8 7.649 7.424 7.649a29.945 29.945 0 007.649-1.125l-.675-6.524-4.047.675"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 196",
  d: "M238.649 31.206h-7.2V16.359h-8.772v37.343h8.773V38.18h7.2v15.522h8.773V16.359h-8.773z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 197",
  d: "M264.968 46.054a4.7 4.7 0 01-2.924 1.575c-1.575 0-2.025-.675-2.025-2.475v-18.9h-8.323v19.575c0 6.074 2.025 8.548 7.2 8.548a14.062 14.062 0 007.874-2.924l1.35 2.475h5.624v-27.67h-8.323v19.8h-.45"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 198",
  d: "M292.412 25.587a8.918 8.918 0 00-6.074 2.7V16.359h-8.323v36.443a23.655 23.655 0 009.673 1.575c6.3 0 12.823-3.374 12.823-16.872 0-9.223-4.272-11.923-8.1-11.923m-4.047 22.046l-2.027-.45V33.006l2.25-.45c1.575 0 2.924 1.35 2.924 6.974s-.9 8.1-3.147 8.1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 255",
  fill: "#15cbbc",
  d: "M0 0h70.779v70.779H0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 199",
  d: "M47.832 15.858l-3.937 23.785-4.1-23.785h-9.132l-3.464 23.628-3.624-23.628h-9.923l8.663 39.062h8.506l4.411-25.517 4.724 25.517h7.718l9.451-39.062z",
  fill: "#fff"
}));

function SvgWalletHub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300.511 70.779"
  }, props), _ref, _ref2);
}

export default SvgWalletHub;